import { homeConstants } from "../constants";

export default function (
  state = {
    isProgress: false,
    data: null,
    error: "",
  },
  action
) {
  switch (action.type) {
    case homeConstants.SIGN_UP_REQUEST:
      return {
        ...state,
        data: {},
        isProgress: true,
      };
    case homeConstants.SIGN_UP_SUCCESS:
      return {
        data: action.response,
        signUpParams: action.params,
        isProgress: false,
      };
    case homeConstants.SIGN_UP_FAILURE:
      return {
        data: null,
        error: action.error,
        isProgress: false,
      };
    case homeConstants.RESET_SIGN_UP_STATUS:
      return {
        ...state,
        data: null,
        signUpParams: null,
        isProgress: false,
      };
    default:
      return state;
  }
}
